var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips-free"},[(!_vm.showDesglose)?_c('TipsInfo',{on:{"show":_vm.show}}):_vm._e(),(_vm.showDesglose)?_c('TipsDesglose',{on:{"show":_vm.show}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }